export default {
  general: {
    pmsEnquirySuccess:
      "Your enquiry has been submitted successfully. Our executive will connect you soon.",
    pkgSubscription: "To Enjoy service make payemnt",
  },
};
